import { get } from 'lodash';
import { PASSWORD_ERROR, PASSWORD_REGEX, MAX_LENGTH_255 } from '../constants/app.constants';

export const checkAtLeastANumber = (value: string) => {
  return PASSWORD_REGEX.digit.test(value);
};

export const checkAtLeastAUppercaseLetter = (value: string) => {
  return PASSWORD_REGEX.capital.test(value);
};

export const checkAtLeastASpecialLetter = (value: string) => {
  return PASSWORD_REGEX.special.test(value);
};

export const getPasswordConfig = () => {
  return {
    required: {
      value: true,
      message: 'This field is required'
    },
    pattern: {
      value: /^\S*$/,
      message: 'Password must not include spaces'
    },
    minLength: {
      value: 8,
      message: PASSWORD_ERROR.minLength,
    },
    maxLength: {
      value: 255,
      message: MAX_LENGTH_255,
    },
    validate: {
      checkAtLeastANumber: checkAtLeastANumber,
      checkAtLeastAUppercaseLetter: checkAtLeastAUppercaseLetter,
      checkAtLeastASpecialLetter: checkAtLeastASpecialLetter,
    },
  }
};

export const getPasswordErrorMessage = (errors: any, fieldName = 'password') => {
  const type = get(errors, `${fieldName}.type`);
  switch (type) {
    case 'checkAtLeastANumber':
      return PASSWORD_ERROR.digit;
    case 'checkAtLeastAUppercaseLetter':
      return PASSWORD_ERROR.capital;
    case 'checkAtLeastASpecialLetter':
      return PASSWORD_ERROR.special;
    default:
      return get(errors, `${fieldName}.message`);
  }
};

export const getApiErrorMessage = (error: any) => {
  return get(error, 'response.data.message') || get(error, 'message', '');
};

export const getApiSuccessMessage = (response: any) => {
  return get(response, 'data.message', 'success');
};

export const isUrl = (name: any) => {
  if(name){
    let res = name.match(/(http(s)?:\/\/.)(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g);
    return (res !== null);
  }
  return null;
}

export const toBase64 = (file: any) => new Promise((resolve, reject) => {
  const reader = new FileReader();
  reader.readAsDataURL(file);
  reader.onload = () => resolve(reader.result);
  reader.onerror = error => reject(error);
});